import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Modal from 'react-modal'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UserContactUpdateModalUI from './UserContactUpdateModalUI.js'

class UserContactUpdateModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,
            submitted: false,
            phoneNumber: null,
            phoneNumberError: null,
            email: '',
            emailError: null,
            state: '',
            stateError: null,
            pinCode: '',
            pinCodeError: null,
            address: '',
            addressError: null
        }
    }

    render() {
        return (
            <UserContactUpdateModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                updateMode={this.props.updateMode}
                onCancelClick={this.props.onCancelClick}
                // phoneNumber
                phoneNumber={this.state.phoneNumber}
                onPhoneNumberChange={(value) => { this.setState({ phoneNumber: value }) }}
                phoneNumberError={this.state.phoneNumberError}
                setPhoneNumberError={(error) => { this.setState({ phoneNumberError: error }) }}
                // email
                email={this.state.email}
                onEmailChange={(event) => { this.setState({ email: event.target.value }) }}
                emailError={this.state.emailError}
                setEmailError={(error) => { this.setState({ emailError: error }) }}
                //state
                state={this.state.state}
                onStateChange={(event) => { this.setState({ state: event.target.value }) }}
                stateError={this.state.stateError}
                setStateError={(error) => { this.setState({ stateError: error }) }}
                //pinCode
                pinCode={this.state.pinCode}
                onPinCodeChange={(event) => { this.setState({ pinCode: event.target.value }) }}
                pinCodeError={this.state.pinCodeError}
                setPinCodeError={(error) => { this.setState({ pinCodeError: error }) }}
                //address
                address={this.state.address}
                onAddressChange={(event) => { this.setState({ address: event.target.value }) }}
                addressError={this.state.addressError}
                setAddressError={(error) => { this.setState({ addressError: error }) }}
                // form events
                onSubmit={this.onSubmit}
                submitted={this.state.submitted}
                setErrorList={this.setErrorList}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        Modal.setAppElement('body')
    }

    onSubmit = () => {
        let submitted = this.state.submitted
        if (submitted)
            return

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        RestApiUtils.put(this.props.context,
            `/api/su/user/${this.props.selectedUserId}/contactInfo`,
            this.onSubmitCallback, {
            phoneNumber: this.state.phoneNumber,
            email: this.state.email,
            state: this.state.state,
            pinCode: this.state.pinCode,
            address: this.state.address
        });
    }

    onSubmitCallback = (response) => {
        let errorList = []
        response.errorList.forEach(error => {
            errorList.push(error.message)
        })

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({
                    successMsg: null
                })
                this.props.onCancelClick()
                this.props.onRefreshClick()
            }, 2000)
        }
    }

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
    }
}

export default withRouter(UserContactUpdateModalSF)
